import { createTicket } from "library/api/zendesk/zendesk";
import { getIsProduction } from "library/browser";
import { GetOverseasTravelParams } from "../../components/OverseasTravel/types";
import { Field } from "../api/zendesk/types.generated";
import { overseasTravelCustomFieldAU } from "./customFieldsMap/overseasTravelCustomFieldsMap";
import { formatDate } from "./zendeskAPI";

const GROUP_ID_AU = { prod: 360002312898, nonProd: 360004390118 };

const FORM_ID_AU = { prod: 360000452458, nonProd: 360002918278 };

const ZENDESK_ADDITIONAL_CARD_FIELDS = [
  { id: overseasTravelCustomFieldAU["Additional Holder 1 - Overseas Travel"] },
  { id: overseasTravelCustomFieldAU["Additional Holder 2 - Overseas Travel"] },
  { id: overseasTravelCustomFieldAU["Additional Holder 3 - Overseas Travel"] },
  { id: overseasTravelCustomFieldAU["Additional Holder 4 - Overseas Travel"] },
  { id: overseasTravelCustomFieldAU["Additional Holder 5 - Overseas Travel"] },
];

function hasAdditionalCardHolders(
  fields: Pick<
    GetOverseasTravelParams,
    "additionalCards" | "additionalCardHolders"
  >,
): Field[] {
  if (fields.additionalCardHolders === "no") return [];

  const additionalCardFields: Field[] = [];
  const additionalCardKeys = Object.keys(fields.additionalCards);

  for (let i = 0; i < additionalCardKeys.length; i++) {
    additionalCardFields.push({
      id: ZENDESK_ADDITIONAL_CARD_FIELDS[i].id,
      value: fields.additionalCards[additionalCardKeys[i]].cardNumber,
    });
  }

  // adding the number of additional cards
  additionalCardFields.push({
    id: overseasTravelCustomFieldAU[
      "Additional Card Holders - Overseas Travel"
    ],
    value: `${additionalCardKeys.length}_additional_card_holders_overseas_travel`,
  });
  return additionalCardFields;
}

export async function createOverseasTravelTicket({
  userName,
  email,
  token,
  ...fields
}: GetOverseasTravelParams) {
  const isProduction = getIsProduction();
  const envKey = isProduction ? "prod" : "nonProd";

  const ticketResponse = await createTicket(
    {
      isNZ: false,
      requester: {
        name: userName,
        email,
      },
      ticketFormId: FORM_ID_AU[envKey],
      groupId: GROUP_ID_AU[envKey],
      subject: "Overseas travel",
      comment:
        "Overseas travel originating from the Latitude Service Centre (LSC).",
      customFields: [
        {
          id: overseasTravelCustomFieldAU["Customers first name"],
          value: fields.firstName,
        },
        {
          id: overseasTravelCustomFieldAU["Surname  (as it appears on ID)"],
          value: fields.lastName,
        },
        {
          id: overseasTravelCustomFieldAU.DOB,
          value: formatDate(fields.dateOfBirth),
        },
        {
          id: overseasTravelCustomFieldAU["Mobile Number"],
          value: fields.mobileNumber,
        },
        {
          id: overseasTravelCustomFieldAU["Departure Date - Overseas Travel"],
          value: formatDate(fields.travelStartDate),
        },
        {
          id: overseasTravelCustomFieldAU["Return Date - Overseas Travel"],
          value: formatDate(fields.travelEndDate),
        },
        {
          id: overseasTravelCustomFieldAU["Destination - Overseas Travel"],
          value: fields.countryOfDestination,
        },
        {
          id: overseasTravelCustomFieldAU[
            "Additional Card Holders - Overseas Travel"
          ],
          value: fields.additionalCardHolders.length,
        },
        ...hasAdditionalCardHolders(fields),
      ],
    },
    token,
  );

  return ticketResponse.data.ticket_id;
}
